import { render, staticRenderFns } from "./HeaderMainMenu.vue?vue&type=template&id=20fd4c17"
import script from "./HeaderMainMenu.vue?vue&type=script&lang=ts"
export * from "./HeaderMainMenu.vue?vue&type=script&lang=ts"
import style0 from "./HeaderMainMenu.vue?vue&type=style&index=0&id=20fd4c17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports